import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CurrencyType, StaminaType } from '../../../../constants/currencies';
import { SelectImageMode } from '../../../../constants/image';
import { SVGIconType } from '../../../../constants/svgIcon';
import { CheckBalance } from '../../../../hooks/useGameCurrency';
import { BalanceType } from '../../../../models/Base';
import {
  CurrencyNode,
  GeneralModal,
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
  SvgIcon,
} from '../../../Molecules';

import styles from './ScanTextImageModal.module.css';

type ScanTextImageModalProps = {
  selectedMode: SelectImageMode | undefined;
  language: string;
  hasOriginalContent: boolean;
  currencyType: CurrencyType;
  fee: number;
  isDisableBackground: boolean;
  checkBalance: CheckBalance;
  onPrimary: (file: File | undefined | null) => void;
  onPressCancel: () => void;
  onClickLanguage: () => void;
};

export const ScanTextImageModal = (props: ScanTextImageModalProps) => {
  const {
    selectedMode,
    language,
    hasOriginalContent,
    currencyType,
    fee,
    isDisableBackground,
    checkBalance,
    onPrimary,
    onPressCancel,
    onClickLanguage,
  } = props;
  const { t } = useTranslation();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    const refCurrent = fileInputRef.current;
    checkBalance(
      currencyType,
      1,
      () => {
        if (refCurrent) {
          refCurrent.click();
        }
      },
      { onShowPopup: onPressCancel },
    );
  };

  return (
    <GeneralModal
      isYesNo={true}
      onYes={handleButtonClick}
      onClose={onPressCancel}
      buttonSetting={{
        noText: t('Cancel'),
        noVariant: GeneralModalNoButtonVariant.Gray,
        yesVariant: GeneralModalYesButtonVariant.Cyan,
        yesText: t('Scan Now'),
      }}
      currencies={[StaminaType.CreationStamina, BalanceType.Token]}
      isDisableBackground={isDisableBackground}
    >
      <div className={styles.scanTextImage}>
        <div className={styles.centerContainer}>
          <SvgIcon name={SVGIconType.OCRScan} className={styles.titleIcon} />
          <p className={styles.titleName}>{t('Scan Text from Image')}</p>

          <p className={styles.textNormal}>
            {t('Select the language of the text.')}
          </p>

          <div className={styles.buttonContainer} onClick={onClickLanguage}>
            <div className={styles.languageSelector}>
              <SvgIcon
                name={SVGIconType.LanguageA}
                width={28}
                height={28}
                color={'white'}
              />
              <span className={styles.language}>{t(language)}</span>
              <SvgIcon
                name={SVGIconType.Triangle}
                width={16}
                height={16}
                color={'white'}
                style={{ marginRight: '4px' }}
              />
            </div>
          </div>

          {hasOriginalContent ? (
            <p className={styles.warningText}>
              {t('Existing text will be replaced.')}
            </p>
          ) : null}
          <div style={{ marginTop: '8px' }}>
            <CurrencyNode currencyType={currencyType} amount={fee} />
          </div>

          <input
            type="file"
            accept="image/*"
            capture={
              selectedMode === SelectImageMode.Camera
                ? 'environment'
                : undefined
            }
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={(e) =>
              onPrimary(e.target.files ? e.target.files[0] : null)
            }
          />
        </div>
      </div>
    </GeneralModal>
  );
};
